import * as React from 'react';
import { Button, Image, Icon } from '@leagueplatform/genesis-core';
import { AssetType } from '@web-config-app/core';
import { PdfIconSvg } from '../../icons/pdf-icon.component';
import { ImagePreviewModal } from '../image-preview-modal/image-preview-modal.component';

export const LeadingThumbnail: React.FC<{
  assetType: AssetType;
  url?: string;
  title?: string;
  description?: string;
}> = ({ assetType, url, title, description }) => {
  const [isPreviewModalOpen, setIsPreviewModalOpen] = React.useState(false);

  if (url && assetType === 'image') {
    return (
      <>
        <Button
          size="small"
          priority="tertiary"
          quiet
          aria-label={`Open ${title} image preview modal`}
          onClick={() => setIsPreviewModalOpen(true)}
          css={{
            padding: 0,
            '&:hover': {
              backgroundColor: 'transparent',
              opacity: 0.8,
            },
          }}
        >
          <Image
            data-testid="leading-thumbnail-image"
            src={url}
            height={40}
            width={40}
            css={{
              objectFit: 'cover',
            }}
          />
        </Button>
        <ImagePreviewModal
          open={isPreviewModalOpen}
          onClose={() => setIsPreviewModalOpen(false)}
          mediaUrl={url}
          title={title}
          description={description}
        />
      </>
    );
  }
  if (assetType === 'pdf') {
    return <Icon data-testid="leading-thumbnail-pdf" icon={<PdfIconSvg />} />;
  }
  return null;
};
